import { v4 as uuid } from 'uuid';

export interface SnapshotImageData {
  url: string;
  lastUpdated?: string | null;
}

export function getSnapshotImageUrl({
  baseUrl,
  image,
  bustCache = false,
}: {
  baseUrl?: string;
  image?: SnapshotImageData | null;
  bustCache?: boolean;
}): string | null {
  if (baseUrl == null || image == null) {
    return null;
  }

  const imageUrl = new URL(`${baseUrl}${image.url}`);
  imageUrl.searchParams.set('lastUpdated', String(getLastUpdated(image)));

  if (bustCache) {
    imageUrl.searchParams.set('cacheBust', uuid());
  }

  return imageUrl.toString();
}

function getLastUpdated(image: SnapshotImageData): number {
  if (image.lastUpdated) {
    return new Date(image.lastUpdated).getTime();
  }

  return Date.now();
}
